import { useEffect } from 'react';
import { X, Undo } from 'lucide-react';

interface ToastProps {
  message: string;
  onClose: () => void;
  onUndo?: () => void;
  duration?: number;
}

export function Toast({ message, onClose, onUndo, duration = 5000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-up">
      <div className="bg-gray-900 text-white rounded-lg shadow-2xl p-4 flex items-center gap-3">
        <p className="flex-1 text-sm font-medium">{message}</p>
        <div className="flex items-center gap-2">
          {onUndo && (
            <button
              onClick={onUndo}
              className="px-3 py-1.5 bg-white text-gray-900 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors flex items-center gap-1.5"
            >
              <Undo size={14} />
              Undo
            </button>
          )}
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
